
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from 'vue-debounce-decorator';
import MagicSearchResult, { FilterModelHit } from '@/models/MagicSearch';
import ProductService from '@/services/ProductService';
import { CbxVariablesModule } from '@/store/modules/CbxVariablesModule';
import LoadMore from '@/components/load-more/LoadMore.vue';
import { FilterModel } from '@/models/Filter';

const ps: ProductService = new ProductService();

@Component({
    name: 'MobileHeaderSearchOverlayModal',
    components: {
        LoadMore,
    },
})
export default class MobileHeaderSearchOverlayModal extends Vue {
    @Prop({ type: Boolean, required: false, default: false }) private displayed: boolean;

    private result: MagicSearchResult = null;
    private isFetching: boolean = false;
    private keyword: string = '';
    private displayOverlay: boolean = false;
    private activeTab: number = 0;

    get translationsReady(): boolean {
        return this.$root.$data.translationsLoaded === true;
    }

    get popularQuery(): FilterModel {
        return {
            categories: [CbxVariablesModule.VARIABLES.rootCategoryId],
            fields: [],
            includedescendantcategories: true,
            count: 12,
            sortoptions: [
                {
                    field: 'data.attributedata.popularity',
                    reverse: true,
                },
            ],
        };
    }
    get products(): FilterModelHit[] {
        return this.result?.products ?? [];
    }

    get categories(): FilterModelHit[] {
        return this.result?.categories ?? [];
    }

    get cmspages(): FilterModelHit[] {
        return this.result?.cmspages ?? [];
    }

    get sortedTabs() {
        const tabs = [
        {
            id: 0,
            key: 'products',
            count: this.result?.productcount || 0,
            label: this.$t('magic-search.products', ['Products']),
            countInfo: `(${this.result?.productcount || 0})`,
        },
        {
            id: 1,
            key: 'categories',
            count: this.result?.categorycount || 0,
            label: this.$t('magic-search.categories', ['Categories']),
            countInfo: `(${this.result?.categorycount || 0})`,
        },
        {
            id: 2,
            key: 'pages',
            count: this.result?.cmscount || 0,
            label: this.$t('magic-search.pages', ['Pages']),
            countInfo: `(${this.result?.cmscount || 0})`,
        },
        ];

        let sortedTabs = tabs.sort((a, b) => {
            if (a.count > 0 !== b.count > 0) {
                return a.count > 0 ? -1 : 1;
            }
            return 0;
        });

        return sortedTabs;
    }

    private async search() {
        this.isFetching = true;
        this.result = await ps.magicSearch(this.keyword);
        this.isFetching = false;

        // Reset active tab
        this.activeTab = this.sortedTabs[0]?.id ?? 0;
    }

    private reset() {
        this.keyword = '';
        this.result = null;
    }

    private setKeyword(input: string) {
        this.keyword = input;
        this.search();
    }

    private async showMore(doctype: string) {
        this.isFetching = true;
        let container = null;
        let offset = 0;
        switch (doctype) {
            case 'PRODUCT':
                container = this.result.products;
                break;
            case 'CATEGORY':
                container = this.result.categories;
                break;
            case 'CMSPAGE':
                container = this.result.cmspages;
                break;
        }
        offset = container.length;

        const response: MagicSearchResult = await ps.magicSearch({
            query: this.keyword,
            doctype: doctype,
            limit: 10,
            offset,
        });

        switch (doctype) {
            case 'PRODUCT':
                this.result.products.push(...response.products);
                break;
            case 'CATEGORY':
                this.result.categories.push(...response.categories);
                break;
            case 'CMSPAGE':
                this.result.cmspages.push(...response.cmspages);
                break;
        }
        this.isFetching = false;
    }

    @Debounce(250)
    private async handleKeywordInput() {
        this.search();
    }

    gotoSearchPage() {
        (window as Window).location.href = `${(window as any).CbxSearchPageUrl}?q=${this.keyword}`;
    }

    @Watch('displayed')
    private onDisplayedChange(n: boolean) {
        if (n) {
            this.reset();
            this.$nextTick(() => (this.$refs.searchInput as any).focus());
        }
    }
}
